import * as React from "react";
import EditFault from "../../Editing/EditFault";
import Table from "../../../components/Table/Table";
import { Dimmer } from "semantic-ui-react";
import { setFaultExtraProperties, getGroupNameByDomainId } from "../../../utils/pdApiUtils";
import { editActions } from "../../../actions/editActions";
import { pdApiActions } from "../../../actions/pdApiActions";
import { mainActions } from "../../../actions/mainActions";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
import _ from "lodash";

/**
 * All the following props are passed from parent component
 */
export type DoorFaultsTableProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  isLoadingFaults: boolean;
  editActions: typeof editActions;
  pdApiActions: typeof pdApiActions;
  mainActions: typeof mainActions;
  subMenuRoute: State.DoorSubmenu;
  toggleModal: () => void;
  columnFilters: Filter[];
  setColumnFilters: (subMenuRoute: State.DoorSubmenu, columnFilter: Filter[]) => void;
};

type DoorFaultsTableState = {
  isModalOpen: boolean;
};

export class DoorFaultsTable extends React.Component<DoorFaultsTableProps, DoorFaultsTableState> {
  state = {
    isModalOpen: false
  };

  componentWillUnmount():void {
    this.props.mainActions.setLastEditedObjectId(undefined);
  }

  componentDidMount(): void {
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };

  render():JSX.Element {
    const { columns, pdApi, mainState, isEditActive, toggleModal, isLoadingFaults } = this.props;
    const { doorFaults } = pdApi;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;
    let doorFaultRows: Api.DoorFault[] = [];
    let selectedColumns: State.Column[] = [];

    doorFaultRows = doorFaults.filter(
      fault => getGroupNameByDomainId(fault.domain.id, pdApi) === "Door"
    ) as Api.DoorFault[];
    doorFaultRows = doorFaultRows.map(row => setFaultExtraProperties(row, pdApi) as Api.DoorFault);
    selectedColumns = columns["Door Faults"];
    const startingPage = mainState.lastEditedObjectId
      ? (doorFaultRows.findIndex(fault => fault.id === mainState.lastEditedObjectId) / // tslint:disable-line: no-bitwise
          mainState.pageSize) >>
        0
      : 0;
    return (
      <div className="flex-1">
        <div className="flex-1">
          <Table
            startingPage={startingPage}
            rows={doorFaultRows}
            loading={isLoadingFaults}
            loadingText="Fetching door faults..."
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={this.props.editActions.select}
            isRowSelected={this.isFaultSelected}
            pageSize={pageSize}
            handleFilterChange={this.handleFilterChangeDebounced}
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div className="edit-view dimmer page" style={{ flex: editSize , width : editSize == 0.3 ? "500px" : "1000px" }}>
              <EditFault toggleModal={toggleModal} columns={columns} />
            </div>
          </Dimmer>
        )}
      </div>
    );
  }

  /**
   * Returns status if fault has been selected
   * @param {Api.Fault} fault
   * @returns {boolean}
   */
  private isFaultSelected = (fault: Api.DoorFault): boolean => {
    const editedObjectId = this.props.editedObjectId ?? this.props.mainState.lastEditedObjectId;
    if (editedObjectId && fault.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

export default DoorFaultsTable;
